import './LazyMarketing.css';

const CompanyDeep = () => {
  const companyData = {
    name: 'Acme Corporation',
    domain: 'acme.com',
    industry: 'Technology',
    employees: '500-1000',
    revenue: '$50M-100M',
    location: 'San Francisco, CA',
    founded: '2015',
    linkedin: 'linkedin.com/company/acme',
    twitter: '@acmecorp',
  };

  const contacts = [
    { name: 'John Smith', title: 'CEO', email: 'john@acme.com', linkedin: true, verified: true },
    { name: 'Sarah Johnson', title: 'VP Marketing', email: 'sarah@acme.com', linkedin: true, verified: true },
    { name: 'Mike Chen', title: 'CTO', email: 'mike@acme.com', linkedin: true, verified: false },
    { name: 'Emily Davis', title: 'Head of Sales', email: 'emily@acme.com', linkedin: false, verified: true },
  ];

  const techStack = ['React', 'Node.js', 'AWS', 'PostgreSQL', 'Kubernetes', 'Datadog'];

  const signals = [
    { type: 'hiring', text: 'Hiring 12 engineering roles', date: '2 days ago', strength: 'high' },
    { type: 'funding', text: 'Series B announced ($45M)', date: '1 week ago', strength: 'high' },
    { type: 'news', text: 'New product launch announced', date: '2 weeks ago', strength: 'medium' },
    { type: 'social', text: 'CEO speaking at SaaStr', date: '3 weeks ago', strength: 'low' },
  ];

  return (
    <div className="lm-page">
      <div className="lm-page-header">
        <div>
          <h1 className="lm-page-title">Company Deep Dive</h1>
          <p className="lm-page-subtitle">Comprehensive intelligence on target accounts</p>
        </div>
      </div>

      <div className="company-deep-layout">
        {/* Company Overview Card */}
        <div className="lm-card company-overview-card">
          <div className="company-header">
            <div className="company-logo">AC</div>
            <div className="company-info">
              <h2 className="company-name">{companyData.name}</h2>
              <div className="company-domain">{companyData.domain}</div>
            </div>
            <span className="badge badge-success">ICP Match: 92%</span>
          </div>

          <div className="company-details-grid">
            <div className="company-detail">
              <span className="detail-label">Industry</span>
              <span className="detail-value">{companyData.industry}</span>
            </div>
            <div className="company-detail">
              <span className="detail-label">Employees</span>
              <span className="detail-value">{companyData.employees}</span>
            </div>
            <div className="company-detail">
              <span className="detail-label">Revenue</span>
              <span className="detail-value">{companyData.revenue}</span>
            </div>
            <div className="company-detail">
              <span className="detail-label">Location</span>
              <span className="detail-value">{companyData.location}</span>
            </div>
            <div className="company-detail">
              <span className="detail-label">Founded</span>
              <span className="detail-value">{companyData.founded}</span>
            </div>
            <div className="company-detail">
              <span className="detail-label">LinkedIn</span>
              <span className="detail-value link">{companyData.linkedin}</span>
            </div>
          </div>
        </div>

        {/* Key Contacts */}
        <div className="lm-card">
          <h3 className="card-title">Key Contacts</h3>
          <div className="contacts-list">
            {contacts.map((contact, idx) => (
              <div key={idx} className="contact-item">
                <div className="contact-avatar">{contact.name.split(' ').map(n => n[0]).join('')}</div>
                <div className="contact-info">
                  <div className="contact-name">
                    {contact.name}
                    {contact.verified && <span className="verified-badge">Verified</span>}
                  </div>
                  <div className="contact-title">{contact.title}</div>
                  <div className="contact-email">{contact.email}</div>
                </div>
                <div className="contact-actions">
                  {contact.linkedin && <button className="icon-btn">in</button>}
                  <button className="icon-btn">Add to Sequence</button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Tech Stack */}
        <div className="lm-card">
          <h3 className="card-title">Technology Stack</h3>
          <div className="tech-stack-grid">
            {techStack.map((tech, idx) => (
              <span key={idx} className="tech-badge">{tech}</span>
            ))}
          </div>
          <p className="tech-note">Detected via BuiltWith and job postings analysis</p>
        </div>

        {/* Buying Signals */}
        <div className="lm-card">
          <h3 className="card-title">Buying Signals</h3>
          <div className="signals-list">
            {signals.map((signal, idx) => (
              <div key={idx} className={`signal-item signal-${signal.strength}`}>
                <div className="signal-icon">
                  {signal.type === 'hiring' && '👥'}
                  {signal.type === 'funding' && '💰'}
                  {signal.type === 'news' && '📰'}
                  {signal.type === 'social' && '🎤'}
                </div>
                <div className="signal-content">
                  <div className="signal-text">{signal.text}</div>
                  <div className="signal-date">{signal.date}</div>
                </div>
                <span className={`signal-strength strength-${signal.strength}`}>
                  {signal.strength}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Engagement Timeline */}
        <div className="lm-card full-width">
          <h3 className="card-title">Engagement Timeline</h3>
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <div className="timeline-title">Email Opened</div>
                <div className="timeline-desc">Sarah Johnson opened "Q4 Planning Guide"</div>
                <div className="timeline-time">Today, 2:34 PM</div>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <div className="timeline-title">Website Visit</div>
                <div className="timeline-desc">Visited pricing page (3 pages, 4 min)</div>
                <div className="timeline-time">Yesterday, 11:20 AM</div>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <div className="timeline-title">Added to Sequence</div>
                <div className="timeline-desc">Added to "Enterprise Outreach Q4"</div>
                <div className="timeline-time">Dec 15, 2024</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyDeep;
